/**
 * Tipo de uma fórmula. Toda fórmula tem um modelo padrão do sistema; o usuário pode
 * escolher um modelo alternativo ou escrever uma expressão personalizada.
 * Espelha o TipoFormulaEnum do back-end.
 */
export enum TipoFormulaEnum {
    ModeloPadrao = 0,
    ModeloAlternativo = 1,
    Personalizada = 2,
}
